export { load } from '@telerik/kendo-intl';
//# sourceMappingURL=coreExports.js.map